import { GraphColor, LocalGraphColour } from "../Colors";
import { green, orange, red, grey, blue } from "@mui/material/colors";

const api = process.env.REACT_APP_API_URL;

/** Normalizes API row value (number or string) for MUI Chip props used in quota modification tables. */
export function getCriticalityChipProps(rawId) {
	const id =
		rawId === null || rawId === undefined || rawId === ""
			? NaN
			: Number(rawId);
	const baseSx = {
		height: "1.8rem",
		minHeight: "1.8rem",
		fontWeight: "bold",
	};
	if (id === 1) {
		return {
			label: "Low",
			sx: { ...baseSx, bgcolor: green[50], color: green[500] },
		};
	}
	if (id === 2) {
		return {
			label: "Medium",
			sx: { ...baseSx, bgcolor: orange[50], color: orange[500] },
		};
	}
	if (id === 3) {
		return {
			label: "High",
			sx: { ...baseSx, bgcolor: red[50], color: red[500] },
		};
	}
	if (id === 4) {
		return {
			label: "Severe",
			sx: { ...baseSx, bgcolor: grey[100], color: grey[700] },
		};
	}
	if (!Number.isFinite(id) || id === 0) {
		return {
			label: "—",
			sx: { ...baseSx, bgcolor: grey[100], color: grey[600] },
		};
	}
	return {
		label: "Other",
		sx: { ...baseSx, bgcolor: blue[50], color: blue[500] },
	};
}

export const urls = {
	quotaStatus: `${api}ApprovalQuotaModification/GetScenarioStatus`,
	userCountries: `${api}GetUserCountries?`,
   quotaForApproval: `${api}ApprovalQuotaModification/GetQuotaforApproval?`,
   popupGraph: `${api}ApprovalQuotaModification/GetPopUpGraphData?`,
   popupGraphDataBySku: `${api}ApprovalQuotaModification/GetPopUpGraphDataBySKU`,
   scenarioModificationList: 
   `${api}ApprovalQuotaModification/GetScenarioModificationList?`,
   Upload : `${api}Approve/Upload`,
   rejectMultiple: `${api}ApprovalQuotaModification/RejectQuotaMultiple?`,
   approve: `${api}ApprovalQuotaModification/ApproveQuotaMultiple?`,
   approveMulWithComment: `${api}ApprovalQuotaModification/ApproveQuotaMultipleComments?`,
   rejectSingle : `${api}ApprovalQuotaModification/RejectQuotaSingle`,
   approveSingle : `${api}ApprovalQuotaModification/ApproveQuota`,
   approveSingleWithComment : `${api}ApprovalQuotaModification/ApproveQuotaComments`,
   Downloadfile: `${api}Define/DownloadFile?`,
};

export const periods = [
	{ key: 1, value: "Current" },
	{ key: 0, value: "Previous" },
];


export function getQuotaModificationTableRows(data) {
   const rows = data?.map((item, index) =>{
      return {
         id: index,
         scenarioId: item.scenarioId,
         criticalityId: item.criticalityId,
         quotaId: item.quotaId,
         scenarioName: item.scenarioName,
         modificationStatus: item.modificationStatus,
         modifiedQuota: item.modifiedQuota, 
         previousQuota: item.previousQuota,
         differenceInQuota: item.differenceInQuota,
         lastActionDate: item.lastActionDate,
         lastActionBy: item.lastActionBy, 
         geoId: item.geoId,
      };
   });
   console.log("Approval_QuotaModification_getQuotaModificationTableRows", rows);
   for(let i=0; i< rows.length; i++){
      rows[i] = getApproveStatus(rows[i]);
   }
   return rows;
}
function  getApproveStatus (item){
	let modificationStatus = item.modificationStatus.toLowerCase();
	const logedUser = JSON.parse(localStorage.getItem("data"));
	if (logedUser.isAnalyst == true) {
		item['canApproveReject'] = false;
      item['canEdit'] = false;
	}
	else {
		if (modificationStatus == "approved" || modificationStatus == "rejected" || modificationStatus == "draft") {
		item['canApproveReject'] = false;
      item['canEdit'] = true;
		}
		else {
		if ((logedUser.isAdmin || (logedUser.isHQUser && logedUser.isApprover))) {
			if (modificationStatus == "normal modified" || modificationStatus == "shift modified" || modificationStatus == "locally approved") {
			item['canApproveReject'] = true;
         item['canEdit'] = false;
			}
		}
		else if (!logedUser.isHQUser) {
			if (modificationStatus == "normal modified" || modificationStatus == "shift modified") {
			item['canApproveReject'] = true;
         item['canEdit'] = false;
			}
			else if (modificationStatus == "locally approved") {
			item['canApproveReject'] = false;
         item['canEdit'] = false;
			}
		}
		}
	}
	return item;
  }

export function preparePopupGraphData(data) {
   if (!data || !Array.isArray(data) || data.length === 0) {
      return { periods: [], seriesData: [], color: [] };
   }

   // API returns rows grouped by period (one row per data source per month), not
   // contiguous blocks per data source.
   const periods = [];
   const periodIndexByLabel = new Map();
   for (let i = 0; i < data.length; i++) {
      const label = data[i].period;
      if (!periodIndexByLabel.has(label)) {
         periodIndexByLabel.set(label, periods.length);
         periods.push(label);
      }
   }

   const dataSources = [];
   const dataSourceKeyToIndex = new Map();
   for (let i = 0; i < data.length; i++) {
      const row = data[i];
      const key = `${row.datasourceID}\u0000${row.dataSourceName}`;
      if (!dataSourceKeyToIndex.has(key)) {
         dataSourceKeyToIndex.set(key, dataSources.length);
         dataSources.push({
            dataSourceName: row.dataSourceName,
            datasourceID: row.datasourceID,
         });
      }
   }

   const normalizeValue = (raw) => {
      let s = raw;
      if (s === "null") {
         return null;
      }
      if (s === 0) {
         return null;
      }
      return s;
   };

   const seriesValues = dataSources.map(() =>
      periods.map(() => null)
   );

   for (let i = 0; i < data.length; i++) {
      const row = data[i];
      const pi = periodIndexByLabel.get(row.period);
      const dsi = dataSourceKeyToIndex.get(
         `${row.datasourceID}\u0000${row.dataSourceName}`
      );
      if (pi === undefined || dsi === undefined) {
         continue;
      }
      seriesValues[dsi][pi] = normalizeValue(row.value);
   }

   const seriesData = dataSources.map((ds, idx) => ({
      name: ds.dataSourceName,
      data: seriesValues[idx],
   }));

   const duplicateDSForColor = data.map((item) => ({
      dataSourceName: item.dataSourceName,
      datasourceID: item.datasourceID,
   }));
   const uniqueSet = new Set(duplicateDSForColor.map(JSON.stringify));
   const dsr = Array.from(uniqueSet).map(JSON.parse);
   const color = [];
   for(let i = 0; i < dsr.length; ++i) {
      if(dsr[i].dataSourceName.toLowerCase().includes('ex-factory')){
         color.push(GraphColor["Ex-Factory"]);
      }else if(dsr[i].dataSourceName.toLowerCase().includes('iqvia - midas')){
         color.push(GraphColor["IQVIA - MIDAS"]);
      }else if(dsr[i].dataSourceName.toLowerCase().includes('forecast')){
         color.push(GraphColor.Forecast);
      }else if(dsr[i].dataSourceName.toLowerCase().includes('modified quota')){
         color.push(GraphColor["Modified Quota"]);
      }else if(dsr[i].dataSourceName.toLowerCase().includes('quota')){
         color.push(GraphColor.Quota);
      }else if(dsr[i].dataSourceName.toLowerCase().includes('sit')){
         color.push(GraphColor.SIT);
      }else if(dsr[i].dataSourceName.toLowerCase().includes('deliveredqty')){
         color.push(GraphColor["DeliveredQTY"]);
      }else if(dsr[i].datasourceID > 5 && dsr[i].datasourceID < 50){
         color.push(LocalGraphColour[dsr[i].datasourceID]);
      }else{
         color.push("#16d620");
      }
   }
   
   const graphData = { periods, seriesData, color };
   console.log("Approval_QuotaModification_preparePopupGraphData", graphData);
   return graphData;
}

export function getScenarioModificationListRows(data, scenarioCanApproveReject) {
   if(data !== undefined && data !== null){
      const rows = data?.map((item, index) => {
         return {
            id: index, 
            scenarioId: item.scenarioId, 
            quotaId: item.quotaId, 
            modificationId: item.modificationId, 
            geoId: item.geoId, 
            modificationNo: item.modificationNo, 
            modificationStatus: item.modificationStatus, 
            differenceInQuota: item.differenceInQuota, 
            lastActionDate: item.lastActionDate,
            lastActionBy: item.lastActionBy, 
         };
      });
      for(let i=0; i< rows.length; i++){
         rows[i] = getApproveStatus_ModificationList(rows[i], scenarioCanApproveReject);
      }
      return rows;
   }
   return null;
}
function  getApproveStatus_ModificationList (item, scenarioCanApproveReject){
	let modificationStatus = item.modificationStatus.toLowerCase();
	const logedUser = JSON.parse(localStorage.getItem("data"));
	if (logedUser.isAnalyst == true) {
		item['canApproveReject'] = false;
      //item['canEdit'] = false;
	}
	else {
		if (modificationStatus == "approved" || modificationStatus == "rejected" || modificationStatus == "draft") {
		item['canApproveReject'] = false;
      //item['canEdit'] = true;
		}
		else {
		if (logedUser.isLocalUser && logedUser.isApprover && modificationStatus == "locally approved") {
			item['canApproveReject'] = false;
         //item['canEdit'] = false;
		}
      else{
         item['canApproveReject'] = scenarioCanApproveReject;
      }
		}
	}
	return item;
  }

export function getModificationPriorTableRows(priorData, latestData, displayModified, selectedModificationNumber) {
   let rows = [];
   if(!displayModified) {
      for(let i = 0; i < priorData.length; ++i) {
         const priorItem = priorData[i];
         if(selectedModificationNumber !==undefined && selectedModificationNumber !== null && selectedModificationNumber !== ""){
            if(priorItem.modificationNo === selectedModificationNumber){
               const item = {
                  id: i, 
                  modificationNo: priorItem.modificationNo, 
                  customerName: priorItem.customerName, 
                  number: priorItem.number, 
                  skuName: priorItem.skuName, 
                  skuNumb: priorItem.skuNumb, 
                  modification1: priorItem.modification1, 
                  modification2: priorItem.modification2, 
                  modification3: priorItem.modification3, 
                  modification4: priorItem.modification4, 
                  modification5: priorItem.modification5,
                  modificationComments : priorItem.modificationComments
               }
               rows.push(item);
            }
         }
         else{
            let length = latestData.length
            let lastModification = latestData[length-1].modificationNo;
            if(priorItem.modificationNo === lastModification){
               const item = {
                  id: i, 
                  modificationNo: priorItem.modificationNo, 
                  customerName: priorItem.customerName, 
                  number: priorItem.number, 
                  skuName: priorItem.skuName, 
                  skuNumb: priorItem.skuNumb, 
                  modification1: priorItem.modification1, 
                  modification2: priorItem.modification2, 
                  modification3: priorItem.modification3, 
                  modification4: priorItem.modification4, 
                  modification5: priorItem.modification5,
                  modificationComments : priorItem.modificationComments
               }
               rows.push(item);
            }
         }
      }
   }
   else {
      for(let i = 0; i < priorData.length; ++i) {
         const priorItem = priorData[i];
         const latestItem = latestData[i];

         const modified = priorItem.modification1 !== latestItem.modification1 ||
         priorItem.modification2 !== latestItem.modification2 ||
         priorItem.modification3 !== latestItem.modification3 ||
         priorItem.modification4 !== latestItem.modification4 ||
         priorItem.modification5 !== latestItem.modification5 || 
         priorItem.modificationComments !== latestItem.modificationComments;

         if(modified) {
            if(selectedModificationNumber !==undefined && selectedModificationNumber !== null && selectedModificationNumber !== ""){
               if(priorItem.modificationNo === selectedModificationNumber){
                  const item = {
                     id: i, 
                     modificationNo: priorItem.modificationNo, 
                     customerName: priorItem.customerName, 
                     number: priorItem.number, 
                     skuName: priorItem.skuName, 
                     skuNumb: priorItem.skuNumb, 
                     modification1: priorItem.modification1, 
                     modification2: priorItem.modification2, 
                     modification3: priorItem.modification3, 
                     modification4: priorItem.modification4, 
                     modification5: priorItem.modification5,
                     modificationComments : priorItem.modificationComments
                  }
                  rows.push(item);
               }
            }
            else{
               let length = latestData.length
               let lastModification = priorData[length-1].modificationNo;
               if(priorItem.modificationNo === lastModification){
                  const item = {
                     id: i, 
                     modificationNo: priorItem.modificationNo, 
                     customerName: priorItem.customerName, 
                     number: priorItem.number, 
                     skuName: priorItem.skuName, 
                     skuNumb: priorItem.skuNumb, 
                     modification1: priorItem.modification1, 
                     modification2: priorItem.modification2, 
                     modification3: priorItem.modification3, 
                     modification4: priorItem.modification4, 
                     modification5: priorItem.modification5,
                     modificationComments : priorItem.modificationComments
                  }
                  rows.push(item);
               }
            }
         }
      }
   }
   console.log("Approval_QuotaModification_getModificationPriorTableRows", rows);
   return rows;
}


export function getModificationLatestTableRows(priorData, latestData, displayModified, selectedModificationNumber) {
   let rows = [];
   if(!displayModified) {
      for(let i = 0; i < priorData.length; ++i) {
         const priorItem = priorData[i];
         const latestItem = latestData[i];
         if(selectedModificationNumber !==undefined && selectedModificationNumber !== null && selectedModificationNumber !== ""){
            if(latestData[i].modificationNo === selectedModificationNumber){
               const item = {
                  id: i, 
                  modificationNo: latestItem.modificationNo, 
                  customerName: latestItem.customerName, 
                  number: latestItem.number, 
                  skuName: latestItem.skuName, 
                  skuNumb: latestItem.skuNumb, 
                  modification1: latestItem.modification1, 
                  modification2: latestItem.modification2, 
                  modification3: latestItem.modification3, 
                  modification4: latestItem.modification4, 
                  modification5: latestItem.modification5,
                  priorModification1 : priorItem.modification1,
                  priorModification2 : priorItem.modification2,
                  priorModification3 : priorItem.modification3,
                  priorModification4 : priorItem.modification4,
                  priorModification5 : priorItem.modification5,
                  modificationComments : latestItem.modificationComments
               }
               rows.push(item);
            }
         }
         else{
            let length = latestData.length
            let lastModification = latestData[length-1].modificationNo;
            if(latestData[i].modificationNo ===lastModification){
               const item = {
                  id: i, 
                  modificationNo: latestItem.modificationNo, 
                  customerName: latestItem.customerName, 
                  number: latestItem.number, 
                  skuName: latestItem.skuName, 
                  skuNumb: latestItem.skuNumb, 
                  modification1: latestItem.modification1, 
                  modification2: latestItem.modification2, 
                  modification3: latestItem.modification3, 
                  modification4: latestItem.modification4, 
                  modification5: latestItem.modification5,
                  priorModification1 : priorItem.modification1,
                  priorModification2 : priorItem.modification2,
                  priorModification3 : priorItem.modification3,
                  priorModification4 : priorItem.modification4,
                  priorModification5 : priorItem.modification5,
                  modificationComments : latestItem.modificationComments
               }
               rows.push(item);
            }
         }
      }
   }
   else {
      for(let i = 0; i < priorData.length; ++i) {
         const priorItem = priorData[i];
         const latestItem = latestData[i];

         const modified = priorItem.modification1 !== latestItem.modification1 ||
         priorItem.modification2 !== latestItem.modification2 ||
         priorItem.modification3 !== latestItem.modification3 ||
         priorItem.modification4 !== latestItem.modification4 ||
         priorItem.modification5 !== latestItem.modification5 ||
         priorItem.modificationComments !== latestItem.modificationComments;

         if(modified) {
            if(selectedModificationNumber !==undefined && selectedModificationNumber !== null && selectedModificationNumber !== ""){
               if(latestData[i].modificationNo === selectedModificationNumber){
                  const item = {
                     id: i, 
                     modificationNo: latestItem.modificationNo, 
                     customerName: latestItem.customerName, 
                     number: latestItem.number, 
                     skuName: latestItem.skuName, 
                     skuNumb: latestItem.skuNumb, 
                     modification1: latestItem.modification1, 
                     modification2: latestItem.modification2, 
                     modification3: latestItem.modification3, 
                     modification4: latestItem.modification4, 
                     modification5: latestItem.modification5,
                     priorModification1 : priorItem.modification1,
                     priorModification2 : priorItem.modification2,
                     priorModification3 : priorItem.modification3,
                     priorModification4 : priorItem.modification4,
                     priorModification5 : priorItem.modification5,
                     modificationComments : latestItem.modificationComments
                  }
                  rows.push(item);
               }
            }else{
               let length = latestData.length
               let lastModification = latestData[length-1].modificationNo;
               if(latestData[i].modificationNo === lastModification){
                  const item = {
                     id: i, 
                     modificationNo: latestItem.modificationNo, 
                     customerName: latestItem.customerName, 
                     number: latestItem.number, 
                     skuName: latestItem.skuName, 
                     skuNumb: latestItem.skuNumb, 
                     modification1: latestItem.modification1, 
                     modification2: latestItem.modification2, 
                     modification3: latestItem.modification3, 
                     modification4: latestItem.modification4, 
                     modification5: latestItem.modification5,
                     priorModification1 : priorItem.modification1,
                     priorModification2 : priorItem.modification2,
                     priorModification3 : priorItem.modification3,
                     priorModification4 : priorItem.modification4,
                     priorModification5 : priorItem.modification5,
                     modificationComments : latestItem.modificationComments
                  }
                  rows.push(item);
               }
            }
         }
      }
   }
   console.log("Approval_QuotaModification_getModificationLatestTableRows", rows);
   return rows;
}
